import React from "react";
import { Sparkles, ArrowRight, Shield } from "lucide-react";

export function FinalCTA({ te, onCta }) {
  return (
    <section className="py-12 lg:py-28 relative overflow-hidden" data-testid="final-cta-section">
      <div className="absolute inset-0 bg-gradient-to-br from-[#D95D39] via-[#C24F2E] to-[#9B3B1E]"></div>
      <div className="absolute inset-0 opacity-20" style={{
        backgroundImage: "radial-gradient(circle at 20% 30%, rgba(255,255,255,0.4) 0%, transparent 50%), radial-gradient(circle at 80% 70%, rgba(255,255,255,0.2) 0%, transparent 50%)"
      }}></div>
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-heading font-extrabold text-3xl sm:text-5xl lg:text-6xl text-white leading-[1.05] mb-4 sm:mb-5">
          {te.final_cta.title}
        </h2>
        <p className="text-white/90 text-base sm:text-lg lg:text-xl max-w-2xl mx-auto mb-6 sm:mb-8 leading-relaxed">
          {te.final_cta.sub}
        </p>
        <button
          onClick={onCta}
          className="inline-flex items-center gap-2 bg-white text-[#292524] font-bold rounded-2xl px-6 sm:px-8 py-4 sm:py-5 text-base sm:text-lg hover:bg-[#FAF6F0] transition-colors shadow-2xl"
          data-testid="final-cta-btn"
        >
          <Sparkles className="w-5 h-5 text-[#D95D39]" />
          {te.final_cta.btn}
          <ArrowRight className="w-5 h-5" />
        </button>
        <div className="mt-6 text-sm text-white/75 flex items-center justify-center gap-2">
          <Shield className="w-4 h-4" />
          <span>{te.final_cta.note}</span>
        </div>
      </div>
    </section>
  );
}
